import { useLoadedData } from '../../toolympus/hooks/useLoadedData';
import { ProjectStatus } from './types';
import { useListItemActions } from '../../toolympus/hooks/useListItemActions';
import { useStatusDates } from '../Settings/useStatusDates';

export const ProjectStatusApiPath = "/api/project/status";

export const useProjectStatuses = (mode: "project" | "process", projectId: number) => {
  const data = useLoadedData<ProjectStatus[]>(
    `${ProjectStatusApiPath}?project_id=${projectId}`,
    [],
    !!projectId && projectId > 0,
  );

  const statusDates = useStatusDates(mode);


  const x = useListItemActions<ProjectStatus>({
    getRecordApiPath: r => r ? `${ProjectStatusApiPath}/${r._id}` : `${ProjectStatusApiPath}`,
    newRecordDefault: { project_id: projectId, description: "", status_date: (statusDates.fieldSchema.values || [])?.filter(x => !data.data.map(y => y.status_date).includes(x.value))[0]?.value },
    onAnySave: () => data.reload(),
    removeMemoTrigger: data.reload,
  })

  return {
    ...data,
    ...x,
    dateSchema: statusDates.fieldSchema,
  };
};
